import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withI18next } from 'lib/i18n/withI18next'
import RelatedProductLayer from 'components/shared/product/product-related/related-product-layer'
import { PDP_WISHLIST_REF_TYPE } from 'components/pdp/const'
import OutfitContext from './context'
import copy from './copy'
import styles from './styles.scss'

export const getOutfitProducts = (products, productId) => {
  const seen = new Set([Number(productId)])
  return (Array.isArray(products) ? products : []).filter((item) => {
    const id = Number(item?.id_product)
    if (
      !id ||
      seen.has(id) ||
      !item?.name ||
      !item?.images?.full_cover_image_path
    )
      return false
    seen.add(id)
    return true
  })
}

const OutfitShopping = ({ products, productId, language, t }) => {
  const items = getOutfitProducts(products, productId).slice(0, 3)
  if (!items.length) return null

  return (
    <section
      className="pdp-outfit-shopping"
      aria-label={copy(t, language, 'title')}
    >
      <style jsx>{styles}</style>
      <OutfitContext.Provider value={items}>
        <RelatedProductLayer
          key={productId}
          showTwoPerRow
          products={items}
          productId={productId}
          refType={PDP_WISHLIST_REF_TYPE.related}
          title={copy(t, language, 'title')}
          elementID={`pdp-outfits-${productId}`}
          displayHoverInteractions
          displayQuickAddToBag
          displayBadges
        />
      </OutfitContext.Provider>
    </section>
  )
}

OutfitShopping.propTypes = {
  products: PropTypes.arrayOf(PropTypes.shape({})),
  productId: PropTypes.number.isRequired,
  language: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
}
OutfitShopping.defaultProps = { products: undefined }

export default connect((state) => ({
  language: state.internationalization.language,
}))(withI18next()(OutfitShopping))
